import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  TextField,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Paper,
  InputAdornment,
  Pagination,
  Stack,
} from "@mui/material";
import { Search } from "lucide-react";

// Sample data - just an array of usernames
const SAMPLE_PLAYERS = [
  "Olafspapi",
  "DocSplinters",
  "HitmanPL47",
  "TriniNicky",
  "Debs6",
  "Bullnikle",
  "DroolSideways16",
  "CHEEKYCAT106",
  "Wo0fie",
  "mauriceblox",
  "Taciturnia",
  "BananaMan1590",
  "Vayetsee",
  "leifykief",
  "DONDORKO",
  "OupiGamer",
  "Wyld1",
  "ColdandLate",
  "BlueysRevenge",
  "Xaviersunsun",
  "Kingswaida",
  "__Lewis",
  "0311Slipstream",
  "Ravenshagh",
  "TabooHarmony151",
  "TomatoCuts",
  "FatPurplePickle",
  "NukeSurveilance",
  "HotRodSkater",
  "oFades",
  "Shamatrix",
  "Mio_Aurelio",
  "__Stryke__",
  "thor_bod",
  "Gejetozaha",
  "LittleBobTables",
  "Dumpycakes",
  "Wummbelbee_",
  "BatFrogSRJ",
  "Ryan_2002",
  "FishRatMan",
  "PrimordialPaw",
  ".MuddyCIeric",
  "__YoMama__",
  "himatthew",
  "classy5653",
  "LeftHandOfD",
  ".GlitteryPuddle3",
  "Klinkenberg_",
  "MossyKut",
  "PixKnight",
  "UmbralPlatypus",
  "Flintaxe",
  "Hyjinksia",
  "TanTan89",
  "Jordy9872",
  "NeonCat1911",
  "MrPortakal",
  "Loeffel_V2",
  "DJ_frostyflakes",
  "Cahee",
  "WoodCK",
  "xXHelmerXx",
  "OrangeNordique",
  "Mdork",
  "Joeykoko1111",
  "_Barthy_",
  "Lumpycheese6875",
  "t4nn3rr",
  "Abigailxoxoxo",
  "Dagbor",
  "Assad89",
  "FlyToPluto",
  "LOCKY914",
  "Zaniley",
  "minecracker88",
  "KnightOwl52",
  ".aazamitsu",
  ".bullnikle",
  "_van1shed_",
  "Qvintex",
  "LazyLIama",
  "reaxpers",
  "RisenPhoenix625",
  "notjukebox7",
  "SocialTech",
  "Loi10",
  "itsfredi1",
  "hyew0n_",
  "TechnoNevrDead",
  "SauckoBones",
  "WibblyWalrus",
  "dree_mi",
  ".StodgySoup44594",
  "Jchagn",
  "Gummball",
  "horaizons",
  "Swordie_",
  "Dulty",
  "distrought",
  "AB_TRAINZ",
  "BrickBuilder206",
  "AvalonHarto",
  "L0renc3",
  "LathropYeovsky",
  "silver_trap",
  "DrBeezBear",
  "MobviousThe2nd",
  "LoneSoul1513",
  "scorto7",
  "Efec201216",
  "Thysie1",
  "ScarletLeaf1000",
  "Waltang",
  "ZAMUK_",
  "YuriNotNow",
  "Angzarr",
  "VietnamBomber123",
  "SilverKraftX",
  "FuegoDragnix",
  "JazzLekture",
  "Quickbunny75",
  "SkarzGamer",
  "Moreminds",
  "FarmerJoe5678",
  "Merdog",
  "palpeh",
  "Mridge9",
  "sweatyrayan",
  "AtemporaI",
  "pippinmin12",
  "TaxEvasion17",
  "Blender3404",
  "Amchaet",
  "JMike03",
  "stonkedman",
  "TheDarkDaylight",
  "TickledProstate",
  "DJLegends42",
  ".Blades13104088",
  "LeHe21",
  "SuperScias",
  "NiceAndEasy",
  "LordOctoGamer",
  "MacLager",
  "KenSenior",
  "ProMasterX21",
  "Redinmybed",
  "Billy_Stacks",
  "Sanzel",
  "MomboJoe",
  "Helmi111",
  "FB6SI",
  ".iamSHIMURA",
  "AJMonster321",
  "sir_patrick1",
  "elementEpoch",
  "KabutoKaiga",
  "tvxkw",
  "Talor5110",
  "dogTwT",
  "LeHe_21",
  "Emancipia",
  "JakobF2013",
  "Vyp",
  "TikiForTheFreaky",
  "EnderFox156",
  ".tSpy3764",
  "MadGamer8872",
  "Scholium",
  "Sw1tchbl4de_22",
  "GreekButcher",
  "Notnotnot777",
  "Moccake",
  "Abyssal_Descent",
  "ToofFairy",
  "Pirate_Kun",
  "Adson102",
  "1870PAFC",
  "chudyPAWI",
  "Fraden",
  "_Tealy",
  "ppaulr",
  "TheBestMemeCat",
  "VigilanceCake",
  "Colling1",
  "knotaj",
  "Lord_Vogel7878",
  "brck_the_beast",
  "Maluhchi",
  "Floneus",
  "HiveCity",
  "lnfl",
  "sayjrock",
  "EfeBeffe",
  "LookAtDaveMan",
  "UnicornTwinkle24",
  "ApothecaryGeorge",
  "Samuli06",
  ".K1ttencrunch",
  "Scumlord",
  "divvrse",
  "thecqueen",
  "WackyZacky538",
  "Jabbathehood08",
  "KAZRYCRAFT",
  "KennyDaBoy",
  "Evildragonx1",
  "domcavi",
  "CanadianGoose695",
  "adamhottie",
  "Rolle1001",
  "MuddyCleric",
  "Rugon9123",
  "atcat_07",
  "Voltnaut",
  "Tharynna",
  "Chomkii",
  "kokoland123",
  "LuXuRiouZ",
  "LunaBee12",
  "Harmonious_Fox22",
  "ItsCaleb404",
  "RiftStudier",
  "Piglinz",
  "CP3HD",
  "sandy_swungg",
  "maisie_squid",
  ".WallopingBoss",
  "Axunan",
  "hsox432",
  "VZYXV",
  "formalkilling",
  "silverfishies",
  "Junkyredd",
  "rickdeventer",
  "Sethraven80",
  "Nukeinacat",
  "Crutan45",
  "MadFox_YT",
  "WesBrix",
  "MoparMike",
  "MechanicalX3",
  "Dawdle_Doodles",
  "Beleeve_",
  "KRTH101",
  "Rudeje11yfish",
  "x_Toaster_x",
  "Diamondlover521",
  "kylejalopi",
  "myrinsk",
  "Bliznamii",
  "oqAree",
  "Romaunt1",
  "NotShinon",
  "axsolotl48",
  "Angcas666",
  ".Farmer_Bort",
  "jimmytro",
  "CalmDinasor796",
  "OneSlimeJelly",
  "CodeCaves",
  "snarebreak",
  "Azarathican",
  "BiggieFresh",
  "reddevils1",
  "Darkness0456",
  "RedShot2010",
  "elomon",
  "Itz_Wafflezz",
  "Cry0nix",
  "Jaebe",
  "NaoEhProfissa",
  "Luxzhv",
  "Oscar578",
  "Forest_Minecraft",
  "chibi21a",
  "Beblith",
  "Miyigi1996",
  "MinningDew",
  "Lindsaym10",
  "Xinos_",
  "Fetterike",
  "Blackstaff_McKoy",
  "McPandapants",
  "Apollo_993",
  "FearlessDazzler",
  "Jay_The_Ay",
  "ASOneiroi",
  "MangoGam1ng",
  "cnivek80",
  "MarcosSalinas",
  "Guudd",
  "Saber5",
  "Rick_mc_",
  "SKYKING4000",
  "confus3dd",
  "Stxrry_zky",
  "JB_Ratz",
  "1Nathan",
  "Dreadelord",
  "xWadge",
  "Matijo9",
  "Nalcot2",
  "myrngsucks",
  "Twistyeys",
  "Linkdash",
  "SarahMolly",
  "illimay",
  "LordMeowMix123",
  "UprightMirror46",
  "EaterOfRears",
  "Kamisanbi",
  "Hiewzy4",
  "RetiarySleet523",
  ".RabidLlama1025",
  "spycoolguy21",
  "Cuts_with_Words",
  "Blazebit",
  "vanillye_h0ney",
  "chiqo",
  "GiorgioG02",
  "FormationPrism",
  "Chickn_wing",
  "notnickegan",
  "cszw",
  "ekq",
  "Haysoos1",
  "RealHakizen",
  "Elrodius",
  "cjayhawk",
  "TiiNakujalka",
  "chopinenjoyer",
  "MissKornel",
  "__Shadow_Ninja__",
  "maggie27063464",
  "Haiqel",
  "JoDxZombie",
  "picledpete",
  "GuerillaMill",
  "ainaofficial",
  "NilsTG",
  "cyndasaur",
  "Scenth",
  "VeryTextured",
  "EjRenegade",
  "Mididams",
  "nlghtek",
  "slumfest",
  "smorelax",
  "EmmiesMom",
  "FalkoderFalko",
  "Brad_BreadStick",
  "TnTJustus",
  "Criticalpact",
  "_Gli1tch",
  "tvattbj0rn",
  "Bobehead42069",
  "JensenCranks90s",
  "beatlecraft",
  "amorchts",
  "wittywolf",
  "original_pyro",
  "DeimosRU",
  "Ali_Alasfoor",
  "Fat_Man_Ian",
  "TSGXeNoZz",
  "s2dbaker",
  "Marhau",
  "MiniatureMango",
  "brogrammer_",
  "bbenz00",
  "SpaceHerpies",
  "mythologists",
  "RoboticCon",
  "BirdPick",
  ".HuaLian5459",
  "Vivi082",
  "KanameTB",
  "TakaoRender",
  "MCVerseCity",
  "Sl33pySun",
  "ReniSETT",
  "ThMindBender",
  "m4rIk0",
  "J0CD",
  "LarsUlrich66",
  "CatticusM",
  "Shadelin_Night",
  "Guy_Johnson",
  "afniko",
  "Krusedd",
  "Kiera7Norece",
  "JwProck",
  "SirElite360",
  "Arion955",
  "Ronoleey",
  "OB_100_2024",
  "zwenvy",
  "PsukheKratos",
  "HD_Pixels",
  "WaitImaGoat",
  "DaRealDIOBrando",
  "Yolkyraindrop",
  "Sar2417",
  "TehNumberOne",
  "Grufted",
  "MajesticFatCatX",
  "Doriok0817",
  "Jhonwillzzz",
  ".Kaderade7694",
  "KujouLunar",
  "DuccGoQuaccc",
  "estroloaben777",
  "thumpyg",
  "Mike_Leetoris",
  "bboofd",
  "Da29767",
  "C0pp3rnicus",
  "SkiDude1119",
  "RobinCould",
  "LETSGOOOOOO0",
  "uhzi",
  "jordan_e",
  "SkyF1ow",
  "BugsBunny93",
  "FireFirst27",
  "millanatato",
  "ATastySandwich98",
  "Flooshy_",
  "OkayAshh",
  "FunnierFive95",
  "Foefii",
  "DrPozitiff",
  "SuperDrangus",
  "EliteAwesome",
  "lukemac9140",
  "zeppelin262",
  "afancypenguin",
  "mikdom23",
  "richelie",
  ".SinningLlama439",
  "nqft",
  "ferrets01",
  "KingWriteThe3rd",
  "AcmeYou",
  "haildamage10",
  "tgallagher",
  "Dinnerbone3845",
  "arachnoscarab",
  "jillilizard",
  "little_android",
  "tupahaot",
  "c0ffee31",
  "crazybroboy5",
  "STOOOOOOOOP",
  "Michaelbro2012",
  "sadmiata1",
  "cwedin78",
  ".chrishens1384",
  ".tt4nn3rr7049",
  "Sayfoulpe",
  "Evilpaydin",
  "Thunderism",
  "DrShapo",
  "PhoenixFire108",
  "urahoexoxo",
  "xCovey",
  "Kroh",
  "Markusknarkus05",
  ".daydream58",
  "REDdog999",
  "BaronHarkozyn",
  "19Schoba98",
  "cool_little_guy",
  "Genwey",
  "Quantum_Fields",
  "GlassyCat705659",
  "Dudesamgaming",
  "KenaiRafe",
  ".BradyHughes",
  "luezt",
  "XmalachiteX",
  "pinkitys",
  "Souperior1337",
  "DoctorD3645",
  "BrodyWavecrusher",
  ".MechanicalX3",
  "LeLemonLime",
  "Nathalius",
  "YourNormalPlayr",
  ".Black_scythe850",
  "IopossomI",
  "MechaBS123",
  "Luxindigo",
  "NaturallyCastle",
  "Angels4Angels",
  "DayHen803069126",
  "Litiagame",
  "plat_e",
  "NeXxBerry",
  "oldfrend",
  "MonsterMetzker",
  "mackint11",
  "Blackbearpnh",
  "ChaikaRaven",
  "O0ren",
  ".TheChayce900",
  "JJU888",
  "YourLocalMosquit",
  "BloodysShadow",
  "Litchytsu",
  "Memonon",
  "Shi_Death",
  "Starrydash",
  "Dandy_Devil",
  "edmeedy",
  "weaponizedzest",
  "sheepinasuit394",
  "ColorMarvin",
  "Darkflame143",
  "Ahbadoo",
  "HadesnoKami",
  "StaceysMomy",
  "SuperDan3",
  "Jacek61Tor",
  "gbital",
  "Insanity946",
  "emty_void763",
  "EmgXErgen",
  "Sxphiie",
  "lolkyuki123",
  "Marius2025_super",
  "Turkari",
  "JadieCrypted",
  "Crittertech",
  "GoldenChance9",
  "SnazzJas",
  "nyyxursobad",
  "TheBlessedTomato",
  "smittieTheHedge",
  "NitroDoggo",
  "DondaLemons",
  "wingman300",
  "eternitti",
  "Username2315",
  "SnackuzTV",
  "Eldor444",
  "CHeezs",
  "Gibahgaming1234",
  "meliodasmmm",
  "4201269",
  "T_r_e_n_d",
  "7wood",
  "CorneliaVnGorder",
  "Manekk98",
  "destinpig",
  "ChrisTheStoic",
  "gejm3r",
  "sylixv",
  "SoyAbMolon",
  "BigLoque",
  "harley09alex",
  "LimeBread27",
  "BurtonGus69",
  "AmokLe",
  "joshi77",
  "BarmyGraph79762",
  "KingKiller1999",
  "HappyBean3",
  "HolyHalos",
  "MrcyberMC",
  "Broleary",
  "KorruptGG1",
  "Zephyrus360",
  "KiralyYork06",
  "Naruuu754",
  "Lionracer11",
  ".ExposedAlloy493",
  "grasseater67",
  "sexyguy431",
  "Hunterfighter55",
  "Hans58",
  "Lucy_P",
  "ikeae",
  "Mayo3946",
  "omerixx",
  "KittenCuddler15",
  "LinkToTheFuture",
  "Fantastiola",
  "builder239",
  "MKtwin2000",
  ".yuomiccia",
  "Noah_W_",
  "nederliver",
  "Dirtmonster",
  "Sal97",
  "nuutzfat",
  "Carlopatra",
  "Lluis82",
  "QueenPeaches99",
  "Birddeh",
  "Zombie_Survivor1",
  "CorgMeister3",
  "FishyPancakes",
  "Creata1234s",
  "QuackQwack",
  "JustARandomBlock",
  "_Staking",
  "_Landry_",
  "dvljuke",
  "TS_Goldey_2332",
  "Emmett14",
  "LanderPVP",
  "KHYJY",
];

const MinecraftHeads = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPlayers, setFilteredPlayers] = useState(SAMPLE_PLAYERS);
  const [hoveredPlayer, setHoveredPlayer] = useState(null);
  const [page, setPage] = useState(1);
  const playersPerPage = 18;

  // Handle search input change and immediately filter results
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Filter players based on search term
    const filtered = SAMPLE_PLAYERS.filter((username) =>
      username.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredPlayers(filtered);
    setPage(1); // Reset to first page when searching
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    setFilteredPlayers(SAMPLE_PLAYERS);
    setPage(1); // Reset to first page when clearing search
  };

  // Handle page change
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Calculate current page's players
  const indexOfLastPlayer = page * playersPerPage;
  const indexOfFirstPlayer = indexOfLastPlayer - playersPerPage;
  const currentPlayers = filteredPlayers.slice(
    indexOfFirstPlayer,
    indexOfLastPlayer
  );
  const totalPages = Math.ceil(filteredPlayers.length / playersPerPage);

  return (
    <div>
      <Box>
        <Typography variant="h3" component="h1" gutterBottom align="left">
          MCV Citizens and friends
        </Typography>

        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <TextField
            fullWidth
            label="Search players"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Type to search..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search size={20} />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <Typography
                    variant="caption"
                    color="primary"
                    sx={{ cursor: "pointer" }}
                    onClick={handleClearSearch}
                  >
                    Clear
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Paper>

        {filteredPlayers.length === 0 ? (
          <Box textAlign="center" py={4}>
            <Typography variant="h6">
              No players found matching "{searchTerm}"
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {currentPlayers.map((username, index) => (
              <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
                <Card
                  onMouseEnter={() => setHoveredPlayer(username)}
                  onMouseLeave={() => setHoveredPlayer(null)}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      boxShadow: (theme) => theme.shadows[8],
                    },
                    width: "100%",
                    position: "relative",
                    // Fixed minimum height to prevent shrinking when hovering
                    minHeight: 180,
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      pt: hoveredPlayer === username ? 0 : 2,
                      height: hoveredPlayer === username ? "100%" : "auto",
                      width: "100%",
                      position:
                        hoveredPlayer === username ? "absolute" : "relative",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: hoveredPlayer === username ? 2 : 1,
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={
                        hoveredPlayer === username
                          ? `https://mc-heads.net/player/${username}/100`
                          : `https://mc-heads.net/avatar/${username}/80`
                      }
                      alt={`${username}'s head`}
                      sx={{
                        height: hoveredPlayer === username ? "auto" : 80,
                        width: hoveredPlayer === username ? "auto" : 80,
                        maxHeight: hoveredPlayer === username ? "100%" : 80,
                        maxWidth: hoveredPlayer === username ? "100%" : 80,
                        objectFit: "contain",
                        imageRendering: "pixelated",
                        padding: hoveredPlayer === username ? "10px" : 0,
                        // Ensure the full body image doesn't get too small
                        minHeight: hoveredPlayer === username ? 160 : "auto",
                        minWidth: hoveredPlayer === username ? 80 : "auto",
                      }}
                    />
                  </Box>
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      textAlign: "center",
                      visibility:
                        hoveredPlayer === username ? "hidden" : "visible",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {hoveredPlayer !== username && (
                      <Typography variant="subtitle1" component="div" noWrap>
                        {username}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Showing {indexOfFirstPlayer + 1}-
            {Math.min(indexOfLastPlayer, filteredPlayers.length)} of{" "}
            {filteredPlayers.length} players
          </Typography>

          {totalPages > 1 && (
            <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="large"
                showFirstButton
                showLastButton
              />
            </Stack>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default MinecraftHeads;
